/* eslint-disable import/prefer-default-export */
export const USED = 'used';
